import React, { useState } from "react";
import { ChevronDown, Search, SlidersHorizontal } from "lucide-react";

const TaskListFilters = ({
    role = "admin",
    searchQuery = "",
    setSearchQuery,
    statusFilter,
    setStatusFilter,
    priorityFilter,
    setPriorityFilter,
    assigneeFilter = "",
    setAssigneeFilter,
    dueFilter = "",
    setDueFilter,
    sortBy = "",
    setSortBy,
    viewFilter,
    setViewFilter,
    todayCount = 0,
    assignOptions = [],
    onAdvancedClick,
    onCompletedFilter,
    hasActiveFilters = false,
    onClearFilters,
}) => {
    const [advancedOpen, setAdvancedOpen] = useState(false);
    const isStaff = role === "staff";

    return (
        <div className="task-toolbar" role="search">
            <div className="task-toolbar__row">
                <label className="task-toolbar__search">
                    <Search size={16} aria-hidden />
                    <input
                        type="search"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery?.(e.target.value)}
                        placeholder="Search tasks"
                        aria-label="Search tasks"
                    />
                </label>

                <select
                    value={statusFilter}
                    onChange={(e) => {
                        const value = e.target.value;
                        if (value === "Completed") onCompletedFilter?.();
                        setStatusFilter(value);
                    }}
                    className="task-toolbar__control"
                    aria-label="Status filter"
                >
                    <option value="">All statuses</option>
                    <option value="active">Active</option>
                    <option value="Open">Open</option>
                    <option value="In Progress">In Progress</option>
                    <option value="Paused">Paused</option>
                    <option value="Blocked">Blocked</option>
                    <option value="Completed">Completed</option>
                </select>

                <select
                    value={priorityFilter}
                    onChange={(e) => setPriorityFilter(e.target.value)}
                    className="task-toolbar__control"
                    aria-label="Priority filter"
                >
                    <option value="">All priorities</option>
                    <option value="high">High</option>
                    <option value="medium">Medium</option>
                    <option value="low">Low</option>
                </select>

                {!isStaff && setAssigneeFilter && (
                    <select
                        value={assigneeFilter}
                        onChange={(e) => setAssigneeFilter(e.target.value)}
                        className="task-toolbar__control"
                        aria-label="Assignee filter"
                    >
                        <option value="">All assignees</option>
                        <option value="unassigned">Unassigned</option>
                        {assignOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                                {opt.label.split(" (")[0]}
                            </option>
                        ))}
                    </select>
                )}

                {!isStaff && setDueFilter && (
                    <select
                        value={dueFilter}
                        onChange={(e) => setDueFilter(e.target.value)}
                        className="task-toolbar__control"
                        aria-label="Due date filter"
                    >
                        <option value="">Any due date</option>
                        <option value="today">Due today</option>
                        <option value="overdue">Overdue</option>
                        <option value="none">No due date</option>
                    </select>
                )}

                <select
                    value={sortBy}
                    onChange={(e) => setSortBy?.(e.target.value)}
                    className="task-toolbar__control"
                    aria-label="Sort tasks"
                >
                    <option value="">Sort: Default</option>
                    <option value="due">Due date</option>
                    <option value="priority">Priority</option>
                    <option value="title">Title</option>
                    <option value="created">Newest</option>
                </select>

                <button
                    type="button"
                    className={`task-toolbar__advanced ${advancedOpen ? "is-open" : ""}`}
                    onClick={() => setAdvancedOpen((v) => !v)}
                    aria-expanded={advancedOpen}
                    aria-controls="task-toolbar-advanced"
                >
                    <SlidersHorizontal size={15} />
                    Advanced
                    <ChevronDown size={14} />
                </button>

                {hasActiveFilters && (
                    <button
                        type="button"
                        onClick={onClearFilters}
                        className="task-toolbar__link"
                    >
                        Clear
                    </button>
                )}
            </div>

            {advancedOpen && (
                <div id="task-toolbar-advanced" className="task-toolbar__extra">
                    {isStaff && (
                        <div className="task-toolbar__pills" role="group" aria-label="Due view">
                            <button
                                type="button"
                                onClick={() => setViewFilter("today")}
                                className={`task-toolbar__pill ${viewFilter === "today" ? "is-active" : ""}`}
                            >
                                Due today
                                {todayCount > 0 && <span>{todayCount}</span>}
                            </button>
                            <button
                                type="button"
                                onClick={() => setViewFilter("all")}
                                className={`task-toolbar__pill ${viewFilter === "all" ? "is-active" : ""}`}
                            >
                                All tasks
                            </button>
                        </div>
                    )}
                    {role === "admin" && (
                        <button
                            type="button"
                            onClick={onAdvancedClick}
                            className="task-toolbar__link"
                        >
                            Create with full details
                        </button>
                    )}
                </div>
            )}
        </div>
    );
};

export default TaskListFilters;
